import React, { useState } from "react";
import ObjectPropertiesPanel from "./properties/ObjectPropertiesPanel";
import { ToolPropertiesPanel } from "./properties/ToolPropertiesPanel";
import ActiveSelectionPropertiesPanel from "./properties/ActiveSelectionPropertiesPanel";
import MapPropertiesPanel from "./properties/MapPropertiesPanel";
const PropertyBar = ({ onChange,
	selectedItem,
	selectedTool,
	canvasRef,
	selectedProperties,
	validation }) => {

	const [displayedLabel, setDisplayedLabel] = useState(false);
	const [typeCapacity, setTypeCapacity] = useState(false);

	const changeDisplayedLabel = (value) => {
		setDisplayedLabel(value);
	};

	const changeTypeCapacity = (value) => {
		setTypeCapacity(value);
	};

	return (
		<div className="properties-gral-configurations">
			{selectedProperties === "default" && <MapPropertiesPanel validation={validation} />}
			{selectedProperties === "node" && <ObjectPropertiesPanel
				key={selectedItem?.id}
				changeDisplayedLabel={changeDisplayedLabel}
				displayedLabel={displayedLabel}
				typeCapacity={typeCapacity}
				changeTypeCapacity={changeTypeCapacity}
				onChange={onChange}
				selectedItem={selectedItem}
				canvasRef={canvasRef} />
			}
			{selectedProperties === "menu" && <ToolPropertiesPanel
				selectedTool={selectedTool}
			/>
			}
			{selectedProperties === "activeSelection" && <ActiveSelectionPropertiesPanel
				onChange={onChange}
				selectedItem={selectedItem}
				canvasRef={canvasRef}
			/>
			}
		</div>
	);
}

export default PropertyBar;